/* DSL Wishlist counter badge in header */
(function(){
  if (!window.DSL_WISHLIST) return;
  function refresh(){
    var n = window.DSL_WISHLIST.get().size;
    document.querySelectorAll("[data-wishlist-count]").forEach(function(el){
      el.textContent = n;
      el.hidden = n === 0;
    });
  }
  document.addEventListener("DOMContentLoaded", refresh);
  document.addEventListener("dsl:wishlist:change", refresh);
})();